
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.863 2.916C14.088 1.226 11.973.38 9.515.38c-2.457 0-4.573.846-6.348 2.536C1.393 4.606.454 6.67.349 9.106l-.031.126v8.19c0 2.54.897 4.709 2.693 6.504 1.795 1.796 3.963 2.694 6.505 2.694 2.54 0 4.703-.898 6.489-2.694 1.784-1.795 2.677-3.964 2.677-6.504V9.106c-.105-2.436-1.045-4.5-2.82-6.19zm-2.41 19.75a6.27 6.27 0 01-3.937 1.34 6.266 6.266 0 01-3.938-1.34 6.48 6.48 0 01-2.33-3.417c1.7 1.848 3.79 2.772 6.268 2.772 2.477 0 4.567-.925 6.268-2.772a6.49 6.49 0 01-2.33 3.417zm2.615-6.19c-.567 1.26-1.445 2.28-2.631 3.056a7.011 7.011 0 01-3.921 1.165 7.087 7.087 0 01-3.938-1.165c-1.197-.777-2.079-1.796-2.646-3.055v-.504c1.806 1.847 4 2.772 6.584 2.772 2.561 0 4.745-.925 6.552-2.772v.504zm-1.922-2.283c-1.281 1.292-2.825 1.937-4.63 1.937-1.807 0-3.355-.645-4.647-1.937-1.291-1.292-1.937-2.84-1.937-4.646s.646-3.35 1.937-4.632c1.292-1.28 2.84-1.92 4.647-1.92 1.805 0 3.349.64 4.63 1.92 1.281 1.282 1.922 2.825 1.922 4.632s-.641 3.354-1.922 4.646z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#0a294a"}})])
          )
        }
      }
    